import HeaderTexts from "../../common/HeaderTexts";
import TextArea from "../../common/TextArea";

const StepFlowNeedsToBeFixed = ({
    jobDescription,
    jobDescriptionError,
    setJobDescription,
    FileUpload
}) => {
    return (
        <div className="mx-3">
            <HeaderTexts
                title="Describe what needs fixing"
                subTitle=""
            />

            <TextArea
                value={jobDescription}
                onChange={setJobDescription}
                error={jobDescriptionError}
            />

            <div className="card mt-3">
                <div className="card-header p-3 pb-0">
                    <h6 className="mb-0">
                        Add photos
                    </h6>
                    <p className="text-sm mb-0">
                        Jobs with photos are more likely to be accepted 
                    </p>
                </div>
                <div className="card-body p-3">
                    {FileUpload}
                </div>
            </div>
        </div>
    );
};

export default StepFlowNeedsToBeFixed;